import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { createMilestone } from "../../../schemas/createMilestone";
import { createEpic } from "../../../services/apiEpic";
import useMutate from "../../../hooks/useMutate";
import useBoardIdByKey from "../../../hooks/useBoardIdByKey";
import {
  buildCreateMilestonePayload,
  CREATE_MILESTONE_DEFAULT_VALUES,
} from "../utils/createMilestoneUtils";

export function useCreateMilestoneForm({ onClose }) {
  const { id } = useBoardIdByKey();
  const queryClient = useQueryClient();

  const formMethods = useForm({
    resolver: yupResolver(createMilestone),
    defaultValues: CREATE_MILESTONE_DEFAULT_VALUES,
  });

  const { handleSubmit } = formMethods;

  const { mutate, isPending: loading } = useMutate(
    createEpic,
    [],
    () => {
      queryClient.invalidateQueries({
        queryKey: ["epic", id],
      });
    },
    () => {
      onClose();
    }
  );

  const submit = useCallback(
    (formData) => {
      mutate(buildCreateMilestonePayload({ boardId: id, formData }));
    },
    [id, mutate]
  );

  return {
    formMethods,
    handleSubmit,
    loading,
    submit,
  };
}
